import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getVideos } from './videosApi';

const initialState = {
    videos: [], // array of videos
    isLoading: false,
    isError: false,
    error: null,
    total: 0,
};

export const fetchVideos = createAsyncThunk('videos/fetchVideos', async ({ tags, search, author, page }) => {
    const { total, data } = await getVideos(tags, search, author, page);
    return { total, data };
});

const videoSlice = createSlice({
    name: 'videos',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchVideos.pending, (state, action) => {
            state.isError = false;
            state.isLoading = true;
        }).addCase(fetchVideos.fulfilled, (state, action) => {
            state.isLoading = false;
            state.videos = action.payload.data;
            state.total = action.payload.total;
        }).addCase(fetchVideos.rejected, (state, action) => {
            state.isLoading = false;
            state.videos = [];
            state.isError = true;
            state.error = action.error?.message;
            state.total = 0;
        });
    },
});

export default videoSlice.reducer;